<template lang="pug">
div(class="subscription-page-modern")
    div(class="page-header")
        div(class="container-fluid px-4 py-4")
            div(class="d-flex justify-content-between align-items-center")
                div
                    h1(class="page-title mb-1") Subscriptions
                    p(class="page-subtitle text-muted mb-0") Manage your subscription offers and services
                div(class="header-actions d-flex align-items-center gap-3")
                    b-button(variant="outline-primary" size="sm" @click="loadSubscriptions" :disabled="loading" class="refresh-btn")
                        b-spinner(v-if="loading" small class="me-2")
                        b-icon(v-else icon="arrow-clockwise" class="me-2")
                        | {{ loading ? 'Loading...' : 'Refresh' }}

    //- div(class="tabs-modern")
    //-     div(class="container-fluid px-4")
    //-         div(class="tabs-wrapper")
    //-             div(v-for="tab in tabs" :key="tab" 
    //-                 :class="['tab-modern', { active: selectedTab === tab }]" 
    //-                 @click="selectedTab = tab")
    //-                 | {{ tab }}

    div(class="content-area")
        div(class="container-fluid px-4 py-4")
            

            div(v-if="loading" class="loading-state")
                div(class="loading-card")
                    b-spinner(variant="primary" class="mb-3")
                    h5 Loading subscriptions...
                    p(class="text-muted mb-0") Please wait while we fetch your subscription offers


            div(v-else-if="error" class="error-state")
                div(class="error-card")
                    div(class="error-icon mb-3")
                        b-icon(icon="exclamation-triangle" scale="3" variant="danger")
                    h5 Unable to load subscriptions
                    p(class="text-muted mb-3") Something went wrong while fetching your subscription offers
                    b-button(variant="primary" @click="loadSubscriptions" class="retry-btn")
                        b-icon(icon="arrow-clockwise" class="me-2")
                        | Try Again


            div(v-else-if="selectedTab === 'Subscription'" class="tab-content")

                div(v-if="active.length === 0" class="empty-state-section")
                    div(class="empty-content")
                        div(class="empty-icon")
                            b-icon(icon="inbox" scale="4")
                        h4 No ongoing subscriptions
                        p You don't have any active subscription offers at the moment

                
                div(v-else class="subscriptions-section")
                    //- div(class="section-title-row mb-4")
                        //- h5 Active Subscriptions
                        //- span(class="count-badge") {{ active.length }} {{ active.length === 1 ? 'offer' : 'offers' }}
                    
                    div(class="cards-container")
                        div(v-for="subscription in active" :key="subscription.crb5c_subscriptionsid" class="subscription-card-elegant" @click="openModal(subscription)")
                            
                
                            div(class="card-content")
                                div(class="status-badges-container-top")
                                    span(v-if="subscription?.subscribed && subscription?.crb5c_amount" class="status-badge success-badge")
                                        b-icon(icon="check-circle-fill" class="mr-1")
                                        | Subscribed
                                    span(v-else-if="subscription?.declined && subscription?.crb5c_amount" class="status-badge declined-badge")
                                        b-icon(icon="x-circle-fill" class="mr-1")
                                        | Did Not Subscribe
                                    span(v-else-if="!subscription?.subscribed && !subscription?.declined && subscription?.crb5c_amount" class="status-badge outstanding-badge")
                                        b-icon(icon="exclamation-circle-fill" class="mr-1")
                                        | Not Subscribed
                                    span(v-else class="status-badge success-badge")
                                        b-icon(icon="check-circle-fill" class="mr-1")
                                        | Acknowledged

                                    span(v-if="subscription?.invoice?.status === 'paid'" class="payment-badge paid-badge")
                                        | Paid
                                    span(v-else-if="subscription?.invoice?.status === 'outstanding'" class="payment-badge outstanding-badge")
                                        | Outstanding
                                
                                div(class="card-header-section")
                                    div(class="left-section")
                                        div(class="subscription-icon-elegant")
                                            b-icon(icon="box-seam" scale="1.5")
                                        div(class="subscription-info")
                                            h6(class="subscription-title") {{ subscription.crb5c_title }}
                                            p(class="subscription-description" v-html="subscription.crb5c_description || 'No description available' ")
                                    
                                    div(class="right-section")

                                div(class="card-footer-section")
                                    div(class="pricing-info")
                                        div(class="price-container")
                                            span(v-if="parseFloat(subscription.crb5c_amount) === 0" class="free-price") Declaration
                                            template(v-else)
                                                span(class="currency-symbol") $
                                                span(class="price-amount") {{ getTotalAmount(subscription) }}
                                        span(class="duration-info") {{ getDuration(subscription) }}
                                    
                                div(class="date-info")
                                        div
                                            p(class="mb-0") Start Date:
                                            span {{ formatDate(subscription.crb5c_datefrom) }}
                                        button(@click="openModal(subscription)" class="btn btn-primary") Show Details


            //- div(v-else-if="selectedTab === 'Acknowledged'" class="tab-content")
            //-     div(v-if="past.length === 0" class="empty-state-section")
            //-         div(class="empty-content")
            //-             div(class="empty-icon")
            //-                 b-icon(icon="clock-history" scale="4")
            //-             h4 No past subscriptions
            //-             p You don't have any past subscription offers

            //-     div(v-else class="subscriptions-section")
            //-         div(class="section-title-row mb-4")
            //-             h5 Past Subscriptions
            //-             span(class="count-badge") {{ past.length }} {{ past.length === 1 ? 'offer' : 'offers' }}
                    
            //-         div(class="cards-container")
            //-             div(v-for="subscription in past" :key="subscription.crb5c_subscriptionsid" class="subscription-card-elegant past-card" @click="openModal(subscription)")
                            
            //-                 div(class="card-content")
            //-                     div(class="card-header-section")
            //-                         div(class="left-section")
            //-                             div(class="subscription-icon-elegant past-icon")
            //-                                 b-icon(icon="box-seam" scale="1.5")
            //-                             div(class="subscription-info")
            //-                                 h6(class="subscription-title") {{ subscription.crb5c_title }}
            //-                                 p(class="subscription-description") {{ subscription.crb5c_description || 'No description available' }}
                                    
            //-                         div(class="right-section")
            //-                             div(class="status-badges-container")
            //-                                 span(class="status-badge expired-badge")
            //-                                     b-icon(icon="clock" class="me-1")
            //-                                     | Expired

            //-                     div(class="card-footer-section")
            //-                         div(class="pricing-info")
            //-                             div(class="price-container")
            //-                                 span(v-if="parseFloat(subscription.crb5c_amount) === 0" class="free-price") FREE
            //-                                 template(v-else)
            //-                                     span(class="currency-symbol") $
            //-                                     span(class="price-amount") {{ getTotalAmount(subscription) }}
            //-                             span(class="duration-info") {{ getDuration(subscription) }}
                                    
            //-                         div(class="date-info")
            //-                             b-icon(icon="calendar2-event" class="me-2")
            //-                             span {{ formatDate(subscription.crb5c_datefrom) }} - {{ formatDate(subscription.crb5c_datetill) }}

    
    b-modal(v-model="showModal" hide-header hide-footer size="lg" centered body-class="p-0")
        div(v-if="selectedSubscription" class="subscription-modal")
            div(class="modal-header-custom")
                div(class="d-flex align-items-center justify-content-between")
                    div(class="d-flex align-items-center")
                        div(class="subscription-icon-large")
                            b-icon(icon="box-seam" scale="2" class="text-white" v-if="selectedSubscription?.crb5c_amount")
                            b-icon(icon="megaphone" v-if="!selectedSubscription?.crb5c_amount")
                        div(class="ms-3")
                            h4(class="mb-1 fw-bold") {{ selectedSubscription.crb5c_title }}
                            span(class="badge" :class="selectedSubscription.subscribed ? 'bg-success' : (selectedSubscription.declined ? 'bg-danger' : (isPastSubscription ? 'bg-secondary' : 'bg-warning'))")  
                                | {{ selectedSubscription.subscribed ? 'Subscribed' : (selectedSubscription.declined ? 'Did Not Subscribe' : (isPastSubscription ? 'Past' : 'Available')) }}
                            span(class="paid-status badge ml-2" :class="selectedSubscription.invoice?.status === 'paid' ? 'bg-success' : 'bg-danger'" v-if="selectedSubscription?.invoice")
                                | {{ selectedSubscription.invoice?.status === 'paid' ? 'Paid' : 'Outstanding' }}
                    b-button(variant="outline-secondary" size="sm" @click="closeModal" class="btn-close-custom")
                        b-icon(icon="x" scale="1.2")

            div(class="modal-body-custom")
                
                div(class="description-section mb-4" v-if="selectedSubscription.crb5c_description")
                    p(class="text-muted mb-0" v-html="selectedSubscription.crb5c_description") 

                
                div(class="details-grid mb-4")
                    div(class="detail-item" v-if="selectedSubscription?.crb5c_amount")
                        div(class="detail-icon")
                            b-icon(icon="currency-dollar" class="text-success")
                        div
                            div(class="detail-label") Base Amount
                            div(class="detail-value") ${{ selectedSubscription.crb5c_amount }}
                    
                    div(class="detail-item" v-if="selectedSubscription?.crb5c_amount && selectedSubscription?.crb5c_gst")
                        div(class="detail-icon")
                            b-icon(icon="percent" class="text-info")
                        div
                            div(class="detail-label") GST ({{ selectedSubscription.crb5c_gst }}%)
                            div(class="detail-value") ${{ getGSTAmount(selectedSubscription) }}
                    
                    div(class="detail-item" v-if="selectedSubscription?.crb5c_amount")
                        div(class="detail-icon")
                            b-icon(icon="cash-stack" class="text-success")
                        div
                            div(class="detail-label") Total Amount
                            div(class="detail-value fw-bold") ${{ getTotalAmount(selectedSubscription) }}
                    
                    div(class="detail-item")
                        div(class="detail-icon")
                            b-icon(icon="clock" class="text-info")
                        div
                            div(class="detail-label") Duration
                            div(class="detail-value") {{ getDuration(selectedSubscription) }}
                    
                    div(class="detail-item")
                        div(class="detail-icon")
                            b-icon(icon="calendar-range" class="text-warning")
                        div
                            div(class="detail-label") Period
                            div(class="detail-value") {{ formatDate(selectedSubscription.crb5c_datefrom) }} - {{ formatDate(selectedSubscription.crb5c_datetill) }}
                    
                    //- div(class="detail-item")
                    //-     div(class="detail-icon")
                    //-         b-icon(icon="arrow-repeat" class="text-secondary")
                        //- div
                        //-     div(class="detail-label") Recurring
                        //-     div(class="detail-value") {{ selectedSubscription.crb5c_recurring ? 'Yes' : 'No' }}

                
                div(v-if="selectedSubscription?.invoice" class="invoice-section")
                    div(class="section-header")
                        b-icon(icon="receipt" class="text-primary me-2")
                        span(class="fw-semibold") Invoice Information
                    
                    div(class="invoice-card")
                        div(class="d-flex justify-content-between align-items-center mb-3")
                            div
                                div(class="invoice-number") {{ selectedSubscription.invoice.id }}
                                div(class="invoice-date text-muted small") {{ formatDate(selectedSubscription.invoice.date) }}
                            div(class="text-end")
                                span(class="badge text-white" :class="selectedSubscription.invoice.status === 'paid' ? 'bg-success' : 'bg-danger'")
                                    | {{ selectedSubscription.invoice.status === 'paid' ? 'Paid' : 'Outstanding' }}

                        div(class="invoice-amounts")
                            div(class="amount-row")
                                span(class="amount-label") Total Amount
                                span(class="amount-value fw-bold") ${{ selectedSubscription.invoice.totalAmount.toFixed(2) }}
                            
                            div(class="amount-row" v-if="selectedSubscription.invoice.paidAmount > 0")
                                span(class="amount-label text-success") Paid Amount
                                span(class="amount-value text-success") ${{ selectedSubscription.invoice.paidAmount.toFixed(2) }}
                            
                            div(class="amount-row" v-if="selectedSubscription.invoice.outstandingAmount > 0")
                                span(class="amount-label text-danger") Outstanding
                                span(class="amount-value text-danger fw-bold") ${{ selectedSubscription.invoice.outstandingAmount.toFixed(2) }}

                        div(v-if="selectedSubscription.invoice.outstandingAmount > 0" class="mt-3")
                            b-button(variant="success" size="sm" @click="goToPayment" class="w-100")
                                b-icon(icon="credit-card" class="me-2")
                                | Pay Now
                        div(v-else class="mt-3 text-center text-success")
                            b-button(class="view-receipt-btn" @click="goToInvoice")
                                b-icon(icon="check-circle" class="me-2")
                                | View Receipt

                
                div(v-if="subscribeError" class="alert alert-danger mt-3 mb-0")
                    b-icon(icon="exclamation-triangle" class="me-2")
                    | {{ subscribeError }}

            
            div(class="modal-footer-custom")
                b-button(v-if="!selectedSubscription.subscribed && !selectedSubscription.declined && !isPastSubscription" 
                         variant="primary" 
                         :disabled="subscribing" 
                         @click="subscribeToSelected"
                         class="flex-fill me-2")
                    b-spinner(v-if="subscribing" small class="me-2")
                    | {{ subscribing ? 'Subscribing...' : 'Subscribe Now' }}
                
                b-button(variant="outline-secondary" @click="declineSubscription" :disabled="subscribing" class="flex-fill" v-if="!selectedSubscription.subscribed && !selectedSubscription.declined && !isPastSubscription")
                    b-spinner(v-if="subscribing" small class="me-2")
                    | {{ subscribing ? 'Processing...' : 'Do not want to subscribe' }}
                b-button(variant="secondary" @click="closeModal" class="flex-fill" v-else)
                    | Close
                    
    
</template>

<script>
import axios from "axios";

export default {
    name: "SubscriptionPage",
    data() {
        return {
            active: [],
            upcoming: [],
            past: [],
            loading: true,
            reloading: false,
            error: false,
            tabs: ["Subscription", "Acknowledged"],
            selectedTab: "Subscription",
            showModal: false,
            selectedSubscription: null,
            subscribing: false,
            subscribeError: null,
        };
    },
    async mounted() {
        this.loadSubscriptions();
    },
    computed: {
        isPastSubscription() {
            if (!this.selectedSubscription) return false;
            return this.past.some(pastSub => pastSub.crb5c_subscriptionsid === this.selectedSubscription.crb5c_subscriptionsid);
        }
    },
    methods: {
        openModal(subscription) {
            this.selectedSubscription = subscription;
            this.showModal = true;
            this.subscribeError = null;
        },
        closeModal() {
            console.log("Closing modal");
            this.showModal = false;
            this.selectedSubscription = null;
            this.subscribeError = null;
        },
        goToPayment() {
            if (this.selectedSubscription?.invoice?.guid) {
                this.$router.push(`/payment?id=${this.selectedSubscription.invoice.guid}`);
                this.closeModal();
            }
        },
        goToInvoice() {
            if (this.selectedSubscription?.invoice?.id) {
                this.$router.push(`/invoice_single?id=${this.selectedSubscription.invoice.id}`);
                this.closeModal();
            }
        },
        async subscribeToSelected() {
            if (!this.selectedSubscription) return;
            this.subscribing = true;
            this.subscribeError = null;
            try {
                const userId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
                const caregiverId = this.$root.currentUser[0]?.crb5c_fow_caregiverid;
                // const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
                const res = await axios.post('/api/subscriptions/subscribe', {
                    crb5c_userid: userId,
                    subscriptionId: this.selectedSubscription.crb5c_subscriptionsid,
                    caregiverId: caregiverId,
                    // _crb5c_clientid_value: clientId,
                });
                console.log("Subscription response:", res.data);
                let invoiceID = res.data.invoice?.id;
                if (invoiceID) {
                    this.$bvToast.toast(`Subscription successful!`, {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        autoHideDelay: 5000,
                    });
                    this.$router.push(`/invoice_single?id=${invoiceID}`);
                }

                this.selectedSubscription.subscribed = true;
                this.closeModal();
                // this.loadSubscriptions();
            } catch (err) {
                this.subscribeError = 'Failed to subscribe. Please try again.';
            } finally {
                this.subscribing = false;
            }
        },
        async declineSubscription() {
            if (!this.selectedSubscription) return;
            this.subscribing = true;
            this.subscribeError = null;
            try {
                const userId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
                const res = await axios.post('/api/subscriptions/decline', {
                    crb5c_userid: userId,
                    subscriptionId: this.selectedSubscription.crb5c_subscriptionsid,
                });
                console.log("Decline response:", res.data);
                
                this.$bvToast.toast(`You have declined this subscription.`, {
                    title: 'Declined',
                    variant: 'info',
                    solid: true,
                    autoHideDelay: 5000,
                });
                
                this.selectedSubscription.declined = true;
                this.selectedSubscription.responded = true;
                this.closeModal();
                this.loadSubscriptions();
            } catch (err) {
                console.error("Decline error:", err);
                this.subscribeError = 'Failed to decline subscription. Please try again.';
            } finally {
                this.subscribing = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            return new Date(dateString).toLocaleDateString("en-GB");
        },
        async loadCurrentUser() {
            while (!this.$root.currentUser[0]) {
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }
        },
        async loadSubscriptions() {
            this.loading = true;
            this.error = false;
            try {
                await this.loadCurrentUser();
                console.log("Current User:", this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid);
                if (this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid) {
                    const { data } = await axios.get(`/api/subscriptions`, {
                        params: { userID: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid }
                    });
                    
                    this.active = data.active || [];
                    this.past = data.past || [];
                    this.upcoming = data.upcoming || [];
                }
            } catch (error) {
                console.error("Error fetching subscriptions:", error);
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        getDuration(subscription) {
            
            const fromDate = new Date(subscription.crb5c_datefrom);
            const tillDate = new Date(subscription.crb5c_datetill);
            
           
            let years = tillDate.getFullYear() - fromDate.getFullYear();
            let months = tillDate.getMonth() - fromDate.getMonth();
            let days = tillDate.getDate() - fromDate.getDate();
            
           
            if (days < 0) {
                months--;
               
                const prevMonth = new Date(tillDate.getFullYear(), tillDate.getMonth(), 0);
                days += prevMonth.getDate();
            }
            
           
            if (months < 0) {
                years--;
                months += 12;
            }
            
     
            months += years * 12;
            
            const lastDayOfEndMonth = new Date(tillDate.getFullYear(), tillDate.getMonth() + 1, 0).getDate();
            if (days > 0 && tillDate.getDate() === lastDayOfEndMonth) {
                months++;
                days = 0;
            }
            
            
            let result = '';
            if (months > 0) {
                result += months === 1 ? '1 month' : `${months} months`;
            }
            if (days > 0) {
                if (result) result += ' ';
                result += days === 1 ? '1 day' : `${days} days`;
            }
            
            return result || '0 days';
        },
        getGSTAmount(subscription) {
            const baseAmount = parseFloat(subscription.crb5c_amount) || 0;
            const gstPercent = parseFloat(subscription.crb5c_gst) || 0;
            return ((baseAmount * gstPercent) / 100).toFixed(2);
        },
        getTotalAmount(subscription) {
            const baseAmount = parseFloat(subscription.crb5c_amount) || 0;
            const gstAmount = parseFloat(this.getGSTAmount(subscription));
            return (baseAmount + gstAmount).toFixed(2);
        },
        getFormattedDate(subscription) {
            
            if (this.isAccepted(subscription)) {
            
                return this.formatDate(subscription.modifiedon);
            }
            return this.formatDate(subscription.createdon);
        }
    },
};
</script>

<style lang="scss" scoped>
// Modern Subscription Page Styles
.subscription-page-modern {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

// Page Header
.page-header {
    background: white;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    
    .page-title {
        font-size: 2rem;
        font-weight: 700;
        color: #1e293b;
        margin: 0;
    }
    
    .page-subtitle {
        font-size: 1rem;
        color: #64748b;
    }
    
    .refresh-btn {
        border-radius: 8px;
        font-weight: 500;
        padding: 0.5rem 1rem;
        border: 1px solid #e2e8f0;
        
        &:hover {
            background: #f8fafc;
            border-color: #cbd5e1;
        }
    }
}

// Modern Tabs
.tabs-modern {
    background: white;
    border-bottom: 1px solid #e2e8f0;
    
    .tabs-wrapper {
        display: flex;
        gap: 0;
        
        .tab-modern {
            padding: 1rem 2rem;
            font-weight: 500;
            color: #64748b;
            cursor: pointer;
            position: relative;
            transition: all 0.2s ease;
            border-bottom: 3px solid transparent;
            
            &:hover {
                color: #3b82f6;
                background: rgba(59, 130, 246, 0.05);
            }
            
            &.active {
                color: #3b82f6;
                font-weight: 600;
                border-bottom-color: #3b82f6;
                background: rgba(59, 130, 246, 0.05);
            }
        }
    }
}

// Content Area
.content-area {
    padding: 2rem 0;
}

// State Cards
.loading-state, .error-state, .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

.loading-card, .error-card, .empty-card {
    background: white;
    padding: 3rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    text-align: center;
    max-width: 400px;
    
    h5 {
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 0.5rem;
    }
    
    p {
        color: #64748b;
        line-height: 1.5;
    }
}

.error-icon, .empty-icon {
    color: #94a3b8;
}

.retry-btn {
    border-radius: 8px;
    font-weight: 500;
    padding: 0.75rem 1.5rem;
}

// Tab Content
.tab-content {
    max-width: 1200px;
    margin: 0 auto;
}

// Empty State
.empty-state-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    
    .empty-content {
        text-align: center;
        max-width: 400px;
        
        .empty-icon {
            color: #9ca3af;
            margin-bottom: 1.5rem;
        }
        
        h4 {
            color: #374151;
            font-weight: 600;
            margin-bottom: 0.75rem;
        }
        
        p {
            color: #6b7280;
            margin: 0;
        }
    }
}

// Section Title
.section-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    h5 {
        color: #374151;
        font-weight: 600;
        font-size: 1.25rem;
        margin: 0;
    }
    
    .count-badge {
        background: #f3f4f6;
        color: #6b7280;
        font-size: 0.875rem;
        font-weight: 500;
        padding: 0.5rem 1rem;
        border-radius: 20px;
    }
}

// Cards Container
.cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 1.5rem;
}

// Elegant Subscription Card (using modal color scheme)
.subscription-card-elegant {
    background: white;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    overflow: hidden;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-color: #52256B;
    }
    
    &.past-card {
        opacity: 0.85;
        
        &:hover {
            opacity: 1;
        }
    }
}

.card-content {
    padding: 1.75rem;
}

.status-badges-container-top {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
}

.card-header-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
}

.left-section {
    display: flex;
    align-items: flex-start;
    flex: 1;
    
    .subscription-icon-elegant {
        width: 56px;
        height: 56px;
        background: linear-gradient(135deg, #52256B 0%, #764ba2 100%);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        flex-shrink: 0;
        margin-right: 1rem;
        
        &.past-icon {
            background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);
        }
    }
    
    .subscription-info {
        flex: 1;
        min-width: 0;
        
        .subscription-title {
            color: #1f2937;
            font-weight: 600;
            font-size: 1.125rem;
            margin: 0 0 0.5rem 0;
            line-height: 1.3;
        }
        
        .subscription-description {
            color: #6b7280;
            font-size: 0.875rem;
            line-height: 1.4;
            margin: 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }
}

.right-section {
    flex-shrink: 0;
    margin-left: 1rem;
}

.status-badges-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
}

.status-badge {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.4rem 0.75rem;
    border-radius: 20px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    
    &.success-badge {
        background: #d1fae5;
        color: #065f46;
    }
    
    &.expired-badge {
        background: #f3f4f6;
        color: #6b7280;
    }
    
    &.declined-badge {
        background: #fee2e2;
        color: #dc2626;
    }
}

.payment-badge {
    font-size: 0.7rem;
    font-weight: 500;
    padding: 0.25rem 0.6rem;
    border-radius: 12px;
    
    &.paid-badge {
        background: #d1fae5;
        color: #065f46;
    }
    
    &.outstanding-badge {
        background: #fee2e2;
        color: #dc2626;
    }
}

.card-footer-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 1rem;
    border-top: 1px solid #f3f4f6;
}

.pricing-info {
    display: flex;
    align-items: center;
    gap: 1rem;
    
    .price-container {
        display: flex;
        align-items: baseline;
        
        .free-price {
            font-size: 1.25rem;
            font-weight: 700;
            color: #059669;
            background: #ecfdf5;
            padding: 0.4rem 0.8rem;
            border-radius: 8px;
        }
        
        .currency-symbol {
            font-size: 1.125rem;
            font-weight: 600;
            color: #52256B;
        }
        
        .price-amount {
            font-size: 1.5rem;
            font-weight: 700;
            color: #52256B;
            margin-left: 0.125rem;
        }
    }
    
    .duration-info {
        color: #6b7280;
        font-size: 0.875rem;
        font-weight: 500;
        background: #f9fafb;
        padding: 0.375rem 0.75rem;
        border-radius: 12px;
    }
}

.date-info {
    display: flex;
    align-items: center;
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 500;
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.subscription-modal {
    
    overflow: hidden;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header-custom {
    background: linear-gradient(135deg, #52256B 0%, #764ba2 100%);
    color: white;
    padding: 1.5rem;
    
    .subscription-icon-large {
        width: 60px;
        height: 60px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        margin-right: 10px;
    }
    
    .btn-close-custom {
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        border-radius: 8px;
        
        &:hover {
            background: rgba(255, 255, 255, 0.3);
            color: white;
        }
    }
    
    .badge {
        font-size: 0.75rem;
        padding: 0.35em 0.8em;
        border-radius: 50px;
    }
}

.modal-body-custom {
    padding: 2rem;
    background: #fafafa;
}

.description-section {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.detail-item {
    background: white;
    padding: 1.25rem;
    border-radius: 12px;
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    .detail-icon {
        width: 40px;
        height: 40px;
        background: #f8fafc;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;
    }
    
    .detail-label {
        font-size: 0.875rem;
        color: #6b7280;
        margin-bottom: 0.25rem;
    }
    
    .detail-value {
        font-weight: 600;
        color: #1f2937;
        font-size: 1rem;
    }
}

.invoice-section {
    margin-top: 2rem;
    
    .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        font-size: 1.1rem;
        color: #374151;
    }
}

.invoice-card {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    border: 2px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    .invoice-number {
        font-weight: 700;
        font-size: 1.1rem;
        color: #1f2937;
        font-family: 'Courier New', monospace;
    }
    
    .invoice-date {
        font-size: 0.875rem;
    }
    
    .invoice-amounts {
        border-top: 1px solid #e5e7eb;
        padding-top: 1rem;
        
        .amount-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
            
            &:last-child {
                margin-bottom: 0;
                padding-top: 0.5rem;
                border-top: 1px solid #e5e7eb;
            }
            
            .amount-label {
                font-size: 0.9rem;
            }
            
            .amount-value {
                font-size: 1rem;
                font-family: 'Courier New', monospace;
            }
        }
    }
}

.modal-footer-custom {
    padding: 1.5rem;
    background: white;
    border-top: 1px solid #e5e7eb;
    display: flex;
    gap: 0.75rem;
    display: flex;
    flex-direction: column;
    
    .btn {
        border-radius: 8px;
        padding: 0.75rem 1.5rem;
        font-weight: 600;
        
        &.btn-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            
            &:hover {
                background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
            }
        }
    }
}


// Responsive Design
@media (max-width: 1024px) {
    .cards-container {
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 1.25rem;
    }
}

@media (max-width: 768px) {
    .page-header {
        .container-fluid {
            padding: 1.5rem 1rem;
        }
        
        .d-flex {
            flex-direction: column;
            align-items: flex-start !important;
            gap: 1rem;
        }
        
        .page-title {
            font-size: 1.75rem;
        }
        
        .header-actions {
            width: 100%;
            justify-content: flex-end;
        }
    }
    
    .tabs-wrapper {
        .tab-modern {
            padding: 0.75rem 1rem;
            font-size: 0.9rem;
        }
    }
    
    .content-area {
        padding: 1rem 0;
        
        .container-fluid {
            padding: 0 1rem;
        }
    }
    
    .cards-container {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
    
    .subscription-card-elegant {
        .card-content {
            padding: 1.5rem;
        }
        
        .card-header-section {
            margin-bottom: 1.25rem;
        }
        
        .left-section {
            .subscription-icon-elegant {
                width: 48px;
                height: 48px;
                margin-right: 0.75rem;
            }
            
            .subscription-info {
                .subscription-title {
                    font-size: 1rem;
                }
            }
        }
        
        .card-footer-section {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
            
            .pricing-info {
                width: 100%;
                justify-content: space-between;
            }
            
            .date-info {
                align-self: flex-end;
            }
        }
    }
    
    .section-title-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
        
        .count-badge {
            align-self: flex-end;
        }
    }
    
    .loading-card, .error-card {
        padding: 2rem 1.5rem;
        margin: 0 1rem;
    }
    
    // Modal responsive styles
    .details-grid {
        grid-template-columns: 1fr;
    }
    
    .modal-header-custom {
        padding: 1.25rem;
        
        .subscription-icon-large {
            width: 50px;
            height: 50px;
        }
    }
    
    .modal-body-custom {
        padding: 1.5rem;
    }
    
    .detail-item {
        padding: 1rem;
    }
}

@media (max-width: 480px) {
    .page-title {
        font-size: 1.5rem;
    }
    
    .tabs-wrapper {
        .tab-modern {
            padding: 0.75rem 0.5rem;
            flex: 1;
            text-align: center;
        }
    }
    
    .card-header-modern {
        .d-flex {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
        }
        
        .status-indicators {
            align-self: flex-end;
            margin-top: -2rem;
        }
    }
    
    .price-display {
        .amount {
            font-size: 1.5rem;
        }
        
        .free-label {
            font-size: 1.25rem;
        }
    }
}
</style>